<template>
  <div class="home-page">
    <div class="cont-alerts">
      <transition name="fade">
        <div :class="['alert alert-holidays', isHoliday ? '' : 'no-holiday']" v-if="showAlert && locale !== 'ja'" >
          <span class="material-symbols-outlined" translate="no">error</span>
          <div class="cont">
            <p class="caption-1" v-html="formatContent('home.alertconditions', $t, localPath)">
            </p>
          </div>
          <button @click="closeAlert">
            <span class="material-symbols-outlined" translate="no">close</span>
          </button>
        </div>
      </transition>

      <transition name="fade">
        <div class="info cod-qr" v-if="showAlert2">
          <div class="cont">
            <p class="caption-1">
              {{ $t("home.caption") }}
            </p>
            <img src="/images/home/qr-code.svg" alt="Código QR para descargar la app de Tradeview Europe"
            width="267" height="121" />
          </div>
          <button @click="closeAlert2">
            <span class="material-symbols-outlined" translate="no">close</span>
          </button>
        </div>
      </transition>
    </div>
    
    <!-- <PreloaderPage /> -->
    <div class="principal-banner">
      <NuxtImg
        v-if="!showVideo"
        :src="isDesktop ? '/images/home/Home-BannerHero.webp' : '/images/home/Home-BannerHero-Mobile.webp'"
        class="video-poster"
        :alt="$t('home.banner.title')"
        :width="isDesktop ? 1440 : 420"
        :height="isDesktop ? 597 : 600"
        format="webp"
        quality="100"
        priority
      />
      <video
        v-else
        ref="video"
        :class="['video', isDesktop ? 'desktop' : 'mobile']"
        preload="auto"
        autoplay
        loop
        muted
        playsinline
      >
        <source :src="isDesktop ? '/images/home/Home-Hero.mp4' : '/images/home/Home-Hero-Mobile.mp4'" type="video/mp4" />
      </video>
      <div class="opacity"></div>
      <div class="content margin-general">
        <div class="container">
          <h1 class="title-banner">
            {{ $t("home.banner.title") }}
  
          <span v-if="isDesktop && locale === 'en'" class="text-wrapper">
            <transition name="carousel">
              <span :key="alternatingText" class="dynamic-text title-banner">
                {{ alternatingText }}
              </span>
            </transition>
          </span>
        </h1>
        <span v-if="isDesktop && locale !== 'en'" class="text-wrapper title-banner">
          <transition name="carousel">
            <span :key="alternatingText" class="dynamic-text title-banner">
              {{ alternatingText }}
            </span>
          </transition>
        </span>
          <span v-if="isDesktop && locale === 'en'" class="title-banner">{{ $t("home.banner.title2") }}</span>
          <span v-if="!isDesktop" :class="locale == 'en'? '': 'title-banner'" class="text-wrapper">
            <transition name="carousel">
              <span :key="alternatingText" class="dynamic-text title-banner">
                {{ alternatingText }}
              </span>
            </transition>
          </span>
          <span v-if="!isDesktop && locale === 'en'" class="title-banner">{{ $t("home.banner.title2") }}</span>
          <div class="descript">
            <p class="description-banner">{{ $t("home.banner.description") }}</p>
            <p class="description-banner">
              {{ $t("home.banner.description2") }}
            </p>
          </div>
          <div class="banner-actions">
            <div class="banner-buttons-group">
              <a :href="getExternalUrl('/register/1/live-account')" target="_blank" class="primary-button-medium" rel="noopener">
                {{ $t("home.banner.button-1") }}
              </a>
              <a :href="getExternalUrl('/register/1/demo-account')" target="_blank" class="second-button-medium-white" rel="noopener">
                {{ $t('home.banner.button-2') }}
              </a>
            </div>
            <p class="hero-entity-disclosure">{{ $t('home.banner.entityDisclosure') }}</p>
          </div>
        </div>
      </div>
    </div>

    <LazyExperienceDiff
      :title="$t('home.experience.title')"
      :subTitle="$t('home.experience.subTitle')"
    />

    <!-- <div class="margin-general banner-img" v-if="locale !== 'ja' && locale !== 'ko' && locale !== 'zh' && locale !== 'pt-br'">
      <client-only>
        <a :href="promoUrl" target="_blank" rel="noopener noreferrer">
          <NuxtImg 
            :src="currentPromoImage" 
            alt="Get CQG free 60 days"
            loading="lazy"
            placeholder
            quality="85"
            format="webp"
          />
        </a>
      </client-only>
    </div> -->

    <LazyspreadsTable :style="degrade"/>

    <LazyAdvantages :title="'advantages.title'" :advantages="advantagesData" />

    <LazyCraftPortafolio
      titleSection="craftPortafoleo.title1"
      descriptionSection="craftPortafoleo.desc"
      :cards="cardsPortafolio"
      :slider="slider"
    />

    <LazyUnleashPotential v-if="locale !== 'ja'" :style="degrade2"/>

    <LazyTradingAccounts v-if="locale !== 'ja'"/>

    <!-- <LazyFeaturecards v-if="locale !== 'ja'"
      :imgUrl="'/images/home/ILC-Component-home-img.png'"
      :imgWidth="574"   
      :imgHeight="612"
      :title="$t('feature.title')"
      :subtitle="$t('feature.subtitle')"
      :cards="featureCards"
    /> -->

    <!-- <LazyMoreResource v-if="locale !== 'ja'"
      :titleH3="'moreresourse.title'"
      :description="'moreresourse.description'"
      :cards="cardsData"
      :padding="'padding-img'"
    /> -->
    <LazyTrustUs view="home" :contentProp="content" :contentProp2="content" />

   <!--  <LazyWhatSay class="what-say" :style="degrade3"/> -->

    <!-- <LazyAwards :data="awards"/> -->

    <client-only>
      <LazyInvestment
        :label="'investment.title'" 
        :buttonConfigs="[
          {
            type: 'external',
            href: getExternalUrl('/register/1/live-account'),
            class: 'primary-button-medium',
            textKey: 'investment.link'
          }
        ]"
      />
    </client-only>

  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, computed } from "vue";
import { useNuxtApp } from '#app'
import { useI18n } from "vue-i18n";
import { formatContent } from '~/utils/formatContent';
import { useExternalUrl } from '@/composables/useExternalUrl';
import { useImage } from '#imports'; 

import LazyExperienceDiff from "~/components/home/ExperienceDiff";
import LazyspreadsTable from "~/components/home/spreadsTable";
import LazyAdvantages from "~/components/home/Advantages";
import LazyCraftPortafolio from "~/components/home/CraftPortafolio";
import LazyTrustUs from "~/components/home/TrustUs";
import LazyAwards from "~/components/home/Awards";
import LazyUnleashPotential from "~/components/home/UnleashPotential";
/* import LazyFeaturecards from "~/components/Featurecards";
import LazyMoreResource from "~/components/home/MoreResource"; */
import LazyInvestment from "~/components/Investment";
import LazyWhatSay from "~/components/home/WhatSay";
import LazyTradingAccounts from "~/components/home/TradingAccounts";
// import PreloaderPage from "~/components/PreloaderPage.vue";

const { getExternalUrl } = useExternalUrl();
const { t, locale } = useI18n();
const { $regulationsVar } = useNuxtApp();

const localPath = useLocalePath();
const nuxtImg = useImage();

const title = t("seo.home.title");
const description = t("seo.home.description");
const imgSeo = 'https://tradeview.eu/images/seo/01Home.jpg'

const currentIndex = ref(0);

let intervalId;
const textKeys = [
  'dynamicTitle.forex',
  'dynamicTitle.stock',
  'dynamicTitle.indices',
  'dynamicTitle.commodities'
];

const alternatingText = computed(() => t(textKeys[currentIndex.value]));

onMounted(() => {
  intervalId = setInterval(() => {
    currentIndex.value = (currentIndex.value + 1) % textKeys.length;
  }, 2500);
});

onUnmounted(() => {
  if (intervalId) {
    clearInterval(intervalId);
  }
});

useSeoMeta({
  title: title,
  ogTitle: title,
  twitterTitle: title,
  description: description,
  ogDescription: description,
  twitterDescription: description,
  ogImage: imgSeo,
  twitterImage: imgSeo,
});

const degradadeImageUrl = '/images/home/Home-Gradient.avif';
const degradadeImageUrl2 = '/images/home/Home-Gradient2.avif';
const degradadeImageUrl3 = '/images/home/Home-Gradient3.avif';

const optimizedDegrade = nuxtImg(degradadeImageUrl, {
  quality: 50,
  format: 'avif',
});
const optimizedDegrade2 = nuxtImg(degradadeImageUrl2, {
  quality: 50,
  format: 'avif',
});
const optimizedDegrade3 = nuxtImg(degradadeImageUrl3, {
  quality: 50,
  format: 'avif',
});

const degrade = computed(() => {
  return {
    '--degrade': `url('${optimizedDegrade}')`,
  };
});
const degrade2 = computed(() => {
  return {
    '--degrade2': `url('${optimizedDegrade2}')`,
  };
});
const degrade3 = computed(() => {
  return {
    '--degrade3': `url('${optimizedDegrade3}')`,
  };
});

const content = ref([
  {
    type: 'list',
    items: ['trust-us.description1', 'trust-us.description2', 'trust-us.description3'],
  },
]);

/* const cardsData = ref([
  {
    imgSrc: "/images/home/communitraders.svg",
    imgWidth: 188,  
    imgHeight: 32, 
    alt: "Communitraders",
    title: "moreresourse.title1",
    desc: "moreresourse.descripitCard1",
    link: "/services/communitraders",
    textLink: "moreresourse.btn-explore",
  },
  {
    imgSrc: "/images/home/TGH-Logo.svg",
    imgWidth: 171,  
    imgHeight: 42, 
    alt: "TradeGateHub TGH",
    title: "moreresourse.title2",
    desc: "moreresourse.descripitCard2",
    link: "/services/tradegatehub-surfs-up",
    textLink: "moreresourse.btn-explore",
  },
  {
    imgSrc: "/images/home/MultiMAM.svg",
    imgWidth: 190,  
    imgHeight: 28,
    alt: "Multiple Account Manager",
    title: "moreresourse.title4",
    desc: "moreresourse.descripitCard4",
    link: "/services/multimam/",
    textLink: "moreresourse.btn-explore",
  },
  {
    imgSrc: "/images/home/vulkanLogo.svg",
    imgWidth: 160,  
    imgHeight: 38,
    alt: "Vulkan Prime",
    title: "moreresourse.title3",
    desc: "moreresourse.descripitCard3",
    link: "/services/vulkan-bridge",
    textLink: "moreresourse.btn-explore",
  },
  {
    imgSrc: "/images/home/ctradericon.svg",
    imgWidth: 176,  
    imgHeight: 40,
    alt: "cTrader Copy",
    title: "moreresourse.title5",
    desc: "moreresourse.descripitCard5",
    link: "/trading/platforms/ctrader-copy/",
    textLink: "moreresourse.btn-explore",
  },
  {
    imgSrc: "/images/home/apix.svg",
    imgWidth: 118,  
    imgHeight: 42,
    alt: "FIX/API",
    title: "moreresourse.title6",
    desc: "moreresourse.descripitCard6",
    link: "/trading/platforms/ctrader-copy/",
    textLink: "moreresourse.btn-explore",
  },
]);
 */
const cardsPortafolio = ref([
  {
    name: "craftPortafoleo.forex",
    description: "craftPortafoleo.forexDescription",
  },
  {
    name: "craftPortafoleo.stock",
    description: "craftPortafoleo.stockDescription",
  },
  /* {
    name: "craftPortafoleo.futures",
    description: "craftPortafoleo.futuresDescription",
  }, */
  {
    name: "craftPortafoleo.commodities",
    description: "craftPortafoleo.commoditiesDescription",
  },
  {
    name: "craftPortafoleo.indices",
    description: "craftPortafoleo.indicesDescription",
  },
]);

const slider = ref([
  {
    img: "/images/home/Home-Portfolio-Forex.png",
    width: 329,   
    height: 277,
    title: "craftPortafoleo.forex",
    description: "craftPortafoleo.forexDescription",
    alt: "Two smartphones displaying stock charts",
  },
  {
    img: "/images/home/Home-Portfolio-Stocks.png",
    width: 318,   
    height: 279,
    title: "craftPortafoleo.stock",
    description: "craftPortafoleo.stockDescription",
    alt: "Tech sector leaders' market capitalization",
  },
  /* {
    img: "/images/home/Home-Portfolio-Futures.png",
    width: 1040,   
    height: 1001,
    title: "craftPortafoleo.futures",
    description: "craftPortafoleo.futuresDescription",
    alt: "Trading platform on a laptop",
  }, */
  {
    img: "/images/home/12.Home-Portfolio-Commodities.png",
    width: 290,   
    height: 260,
    title: "craftPortafoleo.commodities",
    description: "craftPortafoleo.commoditiesDescription",
    alt: "Trading platform on a laptop",
  },
  {
    img: "/images/home/13.Home-Portfolio-Indices.png",
    width: 311,   
    height: 292,
    title: "craftPortafoleo.indices",
    description: "craftPortafoleo.indicesDescription",
    alt: "Trading platform on a laptop",
  },
]);

const advantagesData = ref([
  {
    image: "layers",
    alt: "layers",
    iconSrc: "layers",
    title: "advantages.multiassets",
    description: "advantages.multiassetsDescription",
  },
  {
    image: "feature_search",
    alt: "feature_search",
    iconSrc: "feature_search",
    title: "advantages.regulated",
    description: "advantages.regulatedDescription",
  },
  {
    image: "headset_mic",
    alt: "headset_mic",
    iconSrc: "headset_mic",
    title: "advantages.growth",
    description: "advantages.growthDescription",
  },
  {
    image: "lock",
    alt: "lock",
    iconSrc: "lock",
    title: "advantages.safety",
    description: "advantages.safetyDescription",
  },
  {
    image: "error",
    alt: "error",
    iconSrc: "error",
    title: "advantages.negativeBalance",
    description: "advantages.negativeBalanceDescription",
  },
]);

const awards = ref({
  titlecont: "awards.titlecont",
  descriptcont: "awards.descriptcont",
  cards: [
    { imgSrc: '/images/award/awar-19.svg', alt: 'Best CFDs Broker', title: 'awards.titlecard19', subtitle: 'awards.subtitlecard19', location: 'awards.location19' },
    { imgSrc: '/images/award/awar-18.svg', alt: 'Best Customer Service', title: 'awards.titlecard18', subtitle: 'awards.subtitlecard18', location: 'awards.location18' },
    { imgSrc: '/images/award/awar-17.svg', alt: 'Best International Stocks Broker', title: 'awards.titlecard17', subtitle: 'awards.subtitlecard17', location: 'awards.location17' },
    { imgSrc: '/images/award/awar-16.svg', alt: 'Best Customer Service', title: 'awards.titlecard16', subtitle: 'awards.subtitlecard16', location: 'awards.location16' },
    { imgSrc: '/images/award/awar-15.svg', alt: 'Best International Stocks Broker', title: 'awards.titlecard15', subtitle: 'awards.subtitlecard15', location: 'awards.location15' },
    { imgSrc: '/images/award/awar-14.svg', alt: 'Top Regulated Forex Broker', title: 'awards.titlecard14', subtitle: 'awards.subtitlecard14', location: 'awards.location14' },

    { imgSrc: '/images/award/awar-13.svg', alt: 'Best Multi-Asset Broker', title: 'awards.titlecard13', subtitle: 'awards.subtitlecard13', location: 'awards.location13' },
    { imgSrc: '/images/award/awar-12.svg', alt: 'Highest Value Broker', title: 'awards.titlecard12', subtitle: 'awards.subtitlecard12', location: 'awards.location12' },
    /* { imgSrc: '/images/award/awar-7.svg', alt: 'Best Islamic Account', title: 'awards.titlecard7', subtitle: 'awards.subtitlecard7', location: 'awards.location7' }, */
    { imgSrc: '/images/award/awar-8.svg', alt: 'Best CEO ', title: 'awards.titlecard8', subtitle: 'awards.subtitlecard8', location: 'awards.location8' },
    { imgSrc: '/images/award/awar-9.svg', alt: 'Top 100 FX Companies', title: 'awards.titlecard9', subtitle: 'awards.subtitlecard9', location: 'awards.location9' },
    { imgSrc: '/images/award/awar-10.svg', alt: 'Best Forex Broker', title: 'awards.titlecard10', subtitle: 'awards.subtitlecard10', location: 'awards.location10' },
    { imgSrc: '/images/award/awar-11.svg', alt: 'Best International Broker for Stocks', title: 'awards.titlecard11', subtitle: 'awards.subtitlecard11', location: 'awards.location11' },
    { imgSrc: '/images/award/awar-1.svg', alt: 'Innovative Trading Partner', title: 'awards.titlecard1', subtitle: 'awards.subtitlecard1', location: 'awards.location1' },
    { imgSrc: '/images/award/awar-2.svg', alt: 'Most Transparent Broker', title: 'awards.titlecard2', subtitle: 'awards.subtitlecard2', location: 'awards.location2' },
    { imgSrc: '/images/award/awar-3.svg', alt: 'Lowest Trading Costs Broker', title: 'awards.titlecard3', subtitle: 'awards.subtitlecard3', location: 'awards.location3' },
    { imgSrc: '/images/award/awar-4.svg', alt: 'Most Trusted Broker', title: 'awards.titlecard4', subtitle: 'awards.subtitlecard4', location: 'awards.location4' },
    { imgSrc: '/images/award/awar-5.svg', alt: 'Best ETF Broker', title: 'awards.titlecard5', subtitle: 'awards.titlecard5', location: 'awards.location5' },
    { imgSrc: '/images/award/awar-6.svg', alt: 'Best Forex Trading Experience', title: 'awards.titlecard6', subtitle: 'awards.subtitlecard6', location: 'awards.location6' },
  ],
});

/* const featureCards = ref([
  {
    icon: "compare_arrows",
    title: "feature.card1.title",
    text: "feature.card1.text"
  },
  {
    icon: "receipt",
    title: "feature.card2.title",
    text: "feature.card2.text"
  },
  {
    icon: "acute",
    title: "feature.card3.title",
    text: "feature.card3.text"
  },
  {
    icon: "approval_delegation",
    title: "feature.card4.title",
    text: "feature.card4.text"
  },
]); */

// Active holidays
const closeAlert2 = () => {
  showAlert2.value = false;
};

const showAlert2 = ref(true);

const closeAlert = () => {
  showAlert.value = false;
};

const showAlert = ref(false);

const isHoliday = ref(false);

const getNowInLosAngeles = () => {
  return new Date(new Date().toLocaleString('en-US', { timeZone: 'America/New_York' }));
};

const holidayStart = new Date('2025-08-27T08:45:00'); 
const holidayEnd = new Date('2025-09-01T23:59:59'); 

const checkHoliday = () => {
  const nowInLosAngeles = getNowInLosAngeles();

  isHoliday.value = nowInLosAngeles >= holidayStart && nowInLosAngeles <= holidayEnd;
};

const isDesktop = ref(false);
const showVideo = ref(true);

// Verifica si el tamaño de pantalla es desktop
const checkScreen = () => {
  isDesktop.value = window.innerWidth >= 571;
};

// Configuración de URLs de la promo
/* const promoUrlsConfig = {
  LATAM: { url: 'https://info.tvmarkets.com/es/promofuturos' },
  es: { url: 'https://info.tvmarkets.com/es/promofuturos' },
  default: { url: 'https://info.tvmarkets.com/futurespromo' },
}; */

// Configuración de imágenes móviles
/* const mobileImagesConfig = {
  LATAM: { image: '/images/home/Futures-promo-mobile-SPA.png' },
  es: { image: '/images/home/Futures-promo-mobile-SPA.png' },
  default: { image: '/images/home/Futures-promo-mobile-ENG.png' },
}; */

// Configuración de imágenes desktop
/* const desktopImagesConfig = {
  LATAM: { image: '/images/home/Futures-promo-desktop-SPA.png' },
  es: { image: '/images/home/Futures-promo-desktop-SPA.png' },
  default: { image: '/images/home/Futures-promo-desktop-ENG.png' },
}; */

// Computed: regulación actual
/* const currentRegulation = computed(() =>
  $regulationsVar.getRegulation(locale.value)
); */

// Computed: URL de la promo
/* const promoUrl = computed(() => {
  return (
    promoUrlsConfig[locale.value]?.url ||
    promoUrlsConfig[currentRegulation.value]?.url ||
    promoUrlsConfig.default.url
  );
}); */

// Computed: imagen móvil
/* const imageSrcMobile = computed(() => {
  return (
    mobileImagesConfig[locale.value]?.image ||
    mobileImagesConfig[currentRegulation.value]?.image ||
    mobileImagesConfig.default.image
  );
}); */

// Computed: imagen desktop
/* const imageSrcDesktop = computed(() => {
  return (
    desktopImagesConfig[locale.value]?.image ||
    desktopImagesConfig[currentRegulation.value]?.image ||
    desktopImagesConfig.default.image
  );
});
 */
// Computed: imagen actual según tamaño de pantalla
/* const currentPromoImage = computed(() => {
  return isDesktop.value ? imageSrcDesktop.value : imageSrcMobile.value;
}); */

onMounted(() => {
  // Verificar promociones de días festivos
  checkHoliday();

  // Detectar tamaño inicial
  checkScreen();

  // Escuchar cambios en tamaño
  window.addEventListener('resize', checkScreen);
});
</script>
